module.exports = __webpack_public_path__ + "static/media/img21.c661d1df.JPG";